import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useAuth } from 'hooks/use-auth';
import { useCheckOPTCode } from 'hooks/use-check-otp-code';
import { GET_IN_USER_COOKIE_KEY } from 'utils/constants';
import Cookies from 'js-cookie';
import { Event } from 'utils/helpers';
import useCountDown from 'utils/useCountdown';
import { toast } from 'react-toastify';
import { useLoginByEmailHook } from '../LoginByEmail/hooks';

export const useCheckOtpCodeHook = () => {
  const [code, setCode] = useState('');
  const { t } = useTranslation();
  const { mutate, isLoading } = useCheckOPTCode();
  const { proceedToLogin, isProceedToValidateEmail } = useLoginByEmailHook();
  const {
    session,
    isCheckOTPCodeOpen,
    isUserDuplicateOpen,
    startedLoginByEmailOrSMS,
    handleIsOpenLoginModal,
    handleIsOpenConfirmEmailModal,
    handleIsOpenRegisterModal,
    handleIsOpenResendCodeModal,
    handleIsOpenCheckOTPCodeOpen,
    handleIsOpenLoginByEmailModal,
    handleIsOpenUserDuplicateModal,
    setAuthUser,
  } = useAuth();

  const { waiting_time } = session || { waiting_time: 0 };
  const { timeLeft, actions } = useCountDown(waiting_time, 1000);
  const remainingTime = Math.floor(timeLeft / 1000);
  const { start, reset } = actions;

  const isOpenModal = isCheckOTPCodeOpen || isUserDuplicateOpen;
  const currentFlow =
    startedLoginByEmailOrSMS === 'login_by_email' ? 'email' : 'sms';

  const currentFlowParam =
    currentFlow === 'email' && isUserDuplicateOpen && !isProceedToValidateEmail
      ? 'sms'
      : currentFlow;

  useEffect(() => {
    if (waiting_time && waiting_time > 0 && isOpenModal) start(waiting_time);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waiting_time, isOpenModal]);

  useEffect(() => {
    if (code.length === 6) handleCheckOtpCode();
  }, [code]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCloseCheckOtpCodeModal = () => {
    setCode('');
    handleIsOpenCheckOTPCodeOpen(false);
    handleIsOpenUserDuplicateModal(false);
    reset();
  };

  const handleCheckOtpCode = () => {
    if (!session) return;

    if (isUserDuplicateOpen) {
      Event.push('getin_login_newuser_verif_email_click');
    } else if (currentFlow === 'sms' && !isUserDuplicateOpen) {
      Event.push('getin_login_sucess_verif_sms_click');
    } else {
      Event.push('getin_login_sucess_verif_email_click');
    }

    mutate(
      {
        currentFlow: currentFlowParam,
        ...(isUserDuplicateOpen && { query: 'user-duplicated' }),
        params: {
          session: session.session,
          code,
        },
      },
      {
        onSuccess: ({ data }) => {
          handleCloseCheckOtpCodeModal();
          setCode('');

          if (data.access_token) {
            setAuthUser(JSON.parse(Cookies.get(GET_IN_USER_COOKIE_KEY)!));
            return;
          }

          handleIsOpenRegisterModal(true);
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onError: (error: any) => {
          setCode('');

          toast.error(
            error?.response?.data?.errors?.general ||
              error?.response?.data?.message ||
              'Erro ao enviar os dados. Por favor, tente novamente.'
          );
        },
      }
    );
  };

  const handleClickButtonBack = () => {
    handleCloseCheckOtpCodeModal();
    reset();

    if (isUserDuplicateOpen) {
      handleIsOpenConfirmEmailModal(true);
      handleIsOpenUserDuplicateModal(false);
      return;
    } else if (currentFlow === 'email') {
      return handleIsOpenLoginByEmailModal(true);
    }

    handleIsOpenLoginModal(true);
  };

  const handleNotReceiveTheCodeButton = () => {
    Event.push('getin_login_phone_filled_click');
    setCode('');

    if (isUserDuplicateOpen && session?.email) {
      proceedToLogin({
        email: session?.email,
        userDuplicated: true,
      });

      return start(session.waiting_time);
    }

    handleCloseCheckOtpCodeModal();
    handleIsOpenResendCodeModal(true);
  };

  return {
    code,
    session,
    isLoading,
    isOpenModal,
    remainingTime,
    currentFlow,
    isUserDuplicateOpen,
    handleClickButtonBack,
    handleCloseCheckOtpCodeModal,
    handleNotReceiveTheCodeButton,
    setCode,
    t,
  };
};
